module.exports = __webpack_public_path__ + "static/media/DashboardActive.f7341913.svg";